var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 194,
    viewBox: "0 0 299 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.2131 121.042L146.396 193.69L0 193.69L-6.34986e-06 48.4226L73.2131 121.042Z",
    fill: "url(#paint0_linear_414_54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M201.158 96.8452L298.755 193.69L103.56 193.69L103.56 -1.52588e-05L201.158 96.8452Z",
    fill: "url(#paint1_linear_414_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_54",
    x1: 146.396,
    y1: 193.69,
    x2: 115.827,
    y2: 27.1606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F87F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_414_54",
    x1: 298.755,
    y1: 193.69,
    x2: 257.996,
    y2: -28.3493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F87F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallVector);
export default __webpack_public_path__ + "static/media/smallVector.8212fafd9599d366cff71df896e588f5.svg";
export { ForwardRef as ReactComponent };